import React, { useEffect } from 'react';
import Container from '@mui/material/Container';
import { Grid, Box, Typography, Link, Stack, Divider, ListItem, Skeleton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
// import TwitterIcon from '@mui/icons-material/Twitter';
// import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
// import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
// import MailOutlineIcon from '@mui/icons-material/MailOutline';

import { useLocation, useNavigate, Link as RouterLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCategoriesIncludeVehicle } from '../../server/api/category';
import DreamCarIcon from '../../components/appFooterIcons/dreamCar';

import HomeIcon from '../../components/appFooterIcons/home';
import BuyIcon from '../../components/appFooterIcons/buy';
import SellIcon from '../../components/appFooterIcons/sell';

// import ReviewCard from '../../segment/@common/Review/reviewCard';
import { useDevice } from '../../hooks/useResponsive';

const Footer = () => {
  const navigate = useNavigate();
  const { isMobile } = useDevice();
  const location = useLocation();
  const dispatch = useDispatch();

  // const isTablet = window.innerWidth <= 768;
  // console.log(isTablet)
  // console.log(location?.pathname);
  const isProductSinglePage = /^\/product-single\/[a-zA-Z0-9]+$/.test(location?.pathname);
  // console.log(isProductSinglePage);

  const handleScrollToTop = () => {
    navigate('/search');
  };
  const { categoryList, categoryLoading } = useSelector((state) => ({
    categoryList: state.category.categoryIncludeVehicle?.response?.categoryVehicles,

    categoryLoading: state.category.loading,
  }));
  // console.log(categoryList);

  // const [scrollValue, setScrollValue] = useState();

  // React.useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollValue = window.scrollY;
  //     setScrollValue(scrollValue);
  //   };

  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  // console.log('data :', scrollValue);

  // const footerItems = [
  //   {
  //     itemName: 'Home',
  //     link: '/home',
  //   },
  //   {
  //     itemName: 'Products',
  //     link: '/products',
  //   },

  //   {
  //     itemName: 'Estimate',
  //     link: '/estimate',
  //   },
  //   {
  //     itemName: 'About',
  //     link: '/about',
  //   },
  // ];

  const footerItemsMobile = [
    {
      itemName: 'Home',
      pathName: '/home',
      activeImage: '/assets/appBarIcons/home.png',
      inActiveImage: '/assets/appBarIcons/home.png',
      alt: '1',
    },
    {
      itemName: 'Buy',
      pathName: '/allproducts',
      activeImage: '/assets/appBarIcons/buy.png',
      inActiveImage: '/assets/appBarIcons/buy.png',
      alt: '2',
    },
    {
      itemName: 'Sell',
      pathName: '/sell',
      activeImage: '/assets/appBarIcons/sell.png',
      inActiveImage: '/assets/appBarIcons/sell.png',
      alt: '3',
    },
    {
      itemName: 'Dream Car',
      pathName: '/dream',
      activeImage: '/assets/appBarIcons/dreamCar.png',
      inActiveImage: '/assets/appBarIcons/dreamCar.png',
      alt: '4',
    },
  ];
  const navLinks = [
    { label: 'Home', pathName: '/home' },
    { label: 'Buy Car', pathName: '/allproducts' },
    { label: 'Sell Your Car', pathName: '/sell' },
    { label: 'Dream Car', pathName: '/dream' },
  ];
  useEffect(() => {
    const credentials = {
      dispatch,
    };
    dispatch(getAllCategoriesIncludeVehicle(credentials));
  }, [dispatch]);
  const numberOfSkeletons = 8;

  return (
    <>
      {isMobile ? (
        <>
          {location?.pathname !== '/search' && (
            <Grid
              className=""
              sx={{ pb: isMobile && isProductSinglePage && 8, backgroundColor: '#232323', zIndex: 1520 }}
            >
              <Container maxWidth="md" color="white">
                <Grid container spacing={4} alignItems="flex-start">
                  {/* Logo */}
                  <Grid
                    item
                    xs={12}
                    md={3}
                    display="flex"
                    // justifyContent="center"
                    alignItems="center"
                    sx={{ height: '100%' }}
                  >
                    <Link href="/home" style={{ textDecoration: 'none' }}>
                      <img src={`/assets/logoNew.png`} alt="Logo" style={{ height: '58px', maxWidth: '157px' }} />
                    </Link>
                  </Grid>
                  <Grid item xs={12} md={3} sx={{ height: '100%', flexDirection: 'row', px: 2 }}>
                    <Divider sx={{ borderColor: '#FFFFFF1A', width: '100%', py: 1 }} />
                  </Grid>

                  {/* Navigation Links */}
                  <Grid item xs={12} md={3} sx={{ height: '100%' }}>
                    <Stack mx={2} gap={2} flexDirection="row">
                      <Box display="flex" flexDirection="column" gap={2.2} width="100%">
                        {navLinks.map((item, index) => (
                          <Link
                            key={index}
                            href={item.pathName}
                            style={{
                              textDecoration: 'none',
                              color: '#FFFFFFDE',
                              fontSize: 13,
                            }}
                          >
                            {item.label}
                          </Link>
                        ))}
                      </Box>
                      <Box display="flex" flexDirection="column" gap={2.2} width="100%">
                        {categoryLoading
                          ? // Show skeletons when loading
                            Array.from(new Array(numberOfSkeletons)).map((_, index) => (
                              <ListItem
                                disableGutters
                                key={index}
                                sx={{
                                  fontSize: '13px',
                                  color: '#322B2B',

                                  mb: 1,
                                }}
                              >
                                <Skeleton variant="text" width="4rem" height="1em" animation="wave" />
                              </ListItem>
                            ))
                          : categoryList?.map((category) => (
                              <ListItem
                                disableGutters
                                key={category.id}
                                sx={{ fontSize: '13px', color: '#1D1D1DDE', pt: '0px !important', cursor: 'pointer' }}
                              >
                                <RouterLink
                                  to={`/category-single/${category?.category?._id}`}
                                  style={{ textDecoration: 'none', color: '#FFFFFFDE', fontSize: 13 }}
                                >
                                  {category?.category?.name}
                                </RouterLink>
                              </ListItem>
                            ))}
                      </Box>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={3} sx={{ height: '100%', flexDirection: 'row', px: 2 }}>
                    <Divider sx={{ borderColor: '#FFFFFF1A', width: '100%', py: 1 }} />
                  </Grid>
                  {/* Contact + Social */}
                  <Grid item xs={12} md={6} sx={{ height: '100%' }}>
                    <Box display="flex" flexDirection="column" gap={2} alignItems="center">
                      {/* Social Row */}

                      {/* Contact Info */}
                      <Box display="flex" flexDirection="column" gap={1.5}>
                        <Stack direction="row" gap={4}>
                          <Typography
                            sx={{
                              minWidth: '61px',
                              textAlign: 'end',
                              fontSize: '14px',
                              fontWeight: 300,
                              color: '#FFFFFFDE',
                            }}
                          >
                            Follow us
                          </Typography>
                          <Box display="flex" gap={1}>
                            <a
                              href="https://www.instagram.com/focus_motors_/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <InstagramIcon sx={{ color: 'white' }} />
                            </a>
                            <a
                              href="https://www.facebook.com/search/top?q=focus%20motors"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FacebookIcon sx={{ color: 'white' }} />
                            </a>
                            <a href="https://www.youtube.com/@focusmotors" target="_blank" rel="noopener noreferrer">
                              <YouTubeIcon sx={{ color: 'white' }} />
                            </a>
                          </Box>{' '}
                        </Stack>
                        <Stack direction="row" gap={4}>
                          <Typography
                            sx={{
                              minWidth: '54px',
                              textAlign: 'end',
                              fontSize: '14px',
                              fontWeight: 300,
                              color: '#FFFFFFDE',
                            }}
                          >
                            Write us
                          </Typography>
                          <Typography sx={{ fontSize: '14px', color: '#FFFFFF' }}>info@focusmotors.in</Typography>
                        </Stack>
                        <Stack direction="row" gap={4}>
                          <Typography
                            sx={{
                              minWidth: '55px',
                              textAlign: 'end',
                              fontSize: '14px',
                              fontWeight: 300,
                              color: '#FFFFFFDE',
                            }}
                          >
                            Call us
                          </Typography>
                          <Typography sx={{ fontSize: '14px', color: '#FFFFFF' }}>+91 8590887713</Typography>
                        </Stack>

                        <Stack direction="row" gap={4}>
                          <Typography
                            sx={{
                              minWidth: '55px',
                              textAlign: 'end',
                              fontSize: '14px',
                              fontWeight: 300,
                              color: '#FFFFFFDE',
                            }}
                          >
                            Visit us
                          </Typography>
                          <Typography sx={{ fontSize: '14px', color: '#FFFFFF' }}>
                            Thambanangady, Pandikkad <br /> Malappuram - Kerala
                          </Typography>
                        </Stack>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>

                {/* Bottom line */}
                <Box textAlign="center" sx={{ mt: 4, pb: 14 }}>
                  <Typography fontSize={12} fontWeight={300} color="#FFFFFF">
                    Copyrights © Focus Motors | Powered by{' '}
                    <span style={{ color: '#579AFF', marginLeft: '5px' }}>
                      {' '}
                      <a
                        href="https://osperb.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#579AFF', textDecoration: 'none' }}
                      >
                        Osperb
                      </a>
                    </span>
                  </Typography>
                </Box>
              </Container>
            </Grid>
          )}
        </>
      ) : (
        <>
          {location?.pathname !== '/search' && (
            <Grid
              className=""
              sx={{ pb: isMobile && isProductSinglePage && 8, backgroundColor: '#232323', zIndex: 1520 }}
            >
              <Container maxWidth="md" color="white">
                <Grid container spacing={4} alignItems="flex-start">
                  {/* Logo */}
                  <Grid
                    item
                    xs={12}
                    md={3}
                    display="flex"
                    // justifyContent="center"
                    alignItems="center"
                    sx={{ height: '100%', minHeight: '160px' }}
                  >
                    <Link href="/home" style={{ textDecoration: 'none' }}>
                      <img src={`/assets/logoNew.png`} alt="Logo" style={{ height: '58px', maxWidth: '157px' }} />
                    </Link>
                  </Grid>

                  {/* Navigation Links */}
                  <Grid item xs={12} md={3} sx={{ height: '100%' }}>
                    <Box display="flex" flexDirection="column" gap={2.2}>
                      {navLinks.map((item, index) => (
                        <Link
                          key={index}
                          href={item.pathName}
                          style={{
                            textDecoration: 'none',
                            color: '#FFFFFFDE',
                            fontSize: 13,
                          }}
                        >
                          {item.label}
                        </Link>
                      ))}
                    </Box>
                  </Grid>

                  {/* Contact + Social */}
                  <Grid item xs={12} md={6} sx={{ height: '100%' }}>
                    <Box display="flex" flexDirection="column" gap={2}>
                      {/* Social Row */}
                      <Box display="flex" alignItems="center" gap={2.5}>
                        <Typography sx={{ textAlign: 'end', fontSize: '14px', fontWeight: 300, color: '#FFFFFFDE' }}>
                          Follow us:
                        </Typography>
                        <Box display="flex" gap={1}>
                          <a href="https://www.instagram.com/focus_motors_/" target="_blank" rel="noopener noreferrer">
                            <InstagramIcon sx={{ color: 'white' }} />
                          </a>
                          <a
                            href="https://www.facebook.com/search/top?q=focus%20motors"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FacebookIcon sx={{ color: 'white' }} />
                          </a>
                          <a href="https://www.youtube.com/@focusmotors" target="_blank" rel="noopener noreferrer">
                            <YouTubeIcon sx={{ color: 'white' }} />
                          </a>
                        </Box>
                      </Box>

                      {/* Contact Info */}
                      <Box display="flex" flexDirection="column" gap={1.5}>
                        <Stack direction="row" gap={4}>
                          <Typography
                            sx={{
                              minWidth: '55px',
                              textAlign: 'end',
                              fontSize: '14px',
                              fontWeight: 300,
                              color: '#FFFFFFDE',
                            }}
                          >
                            Write us:
                          </Typography>
                          <Typography sx={{ fontSize: '14px', color: '#FFFFFF' }}>info@focusmotors.in</Typography>
                        </Stack>
                        <Stack direction="row" gap={4}>
                          <Typography
                            sx={{
                              minWidth: '55px',
                              textAlign: 'end',
                              fontSize: '14px',
                              fontWeight: 300,
                              color: '#FFFFFFDE',
                            }}
                          >
                            Call us:
                          </Typography>
                          <Typography sx={{ fontSize: '14px', color: '#FFFFFF' }}>+91 8590887713</Typography>
                        </Stack>

                        <Stack direction="row" gap={4}>
                          <Typography
                            sx={{
                              minWidth: '55px',
                              textAlign: 'end',
                              fontSize: '14px',
                              fontWeight: 300,
                              color: '#FFFFFFDE',
                            }}
                          >
                            Visit us:
                          </Typography>
                          <Typography sx={{ fontSize: '14px', color: '#FFFFFF' }}>
                            Thambanangady, Pandikkad <br /> Malappuram - Kerala
                          </Typography>
                        </Stack>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>

                {/* Bottom line */}
                <Box textAlign="center" sx={{ mt: 4, pb: 4 }}>
                  <Typography fontSize={12} fontWeight={300} color="#FFFFFF">
                    Copyrights © Focus Motors | Powered by{' '}
                    <span style={{ color: '#579AFF', marginLeft: '5px' }}>
                      {' '}
                      <a
                        href="https://osperb.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#579AFF', textDecoration: 'none' }}
                      >
                        Osperb
                      </a>
                    </span>
                  </Typography>
                </Box>
              </Container>
            </Grid>
          )}
        </>
      )}

      {/* white section */}
      <Grid
        container
        spacing={1}
        className="app-bar"
        sx={{
          padding: '13px 13px',
          display: { sx: 'flex', sm: 'none' },
          flexDirection: { sx: 'row' },
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 4500,
          backgroundColor: '#1F1F1F',
          // borderRadius: '10px',
          boxShadow: '0 10px 10px rgba(0, 0, 0, 0.9)',
          justifyContent: 'space-between',
          width: '100%',
          margin: 'auto',
        }}
      >
        {footerItemsMobile?.slice(0, 2)?.map((item, key) => (
          <Grid key={key} display="flex" alignItems="center">
            <Link href={item?.pathName} style={{ textDecoration: 'none' }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'column' },
                  alignItems: 'center',
                  marginLeft: '5px',
                }}
              >
                {item?.itemName === 'Home' ? (
                  <HomeIcon color={location.pathname === item.pathName ? '#FFA800' : '#FFFFFF99'} />
                ) : (
                  <BuyIcon color={location.pathname === item.pathName ? '#FFA800' : '#FFFFFF99'} />
                )}
                {/* ffa800 */}
                <Typography
                  textAlign={'center'}
                  fontSize={12}
                  fontWeight={400}
                  sx={{ color: location.pathname === item.pathName ? '#FFA800' : '#FFFFFF99' }}
                >
                  {' '}
                  {item?.itemName}
                </Typography>
              </Box>
            </Link>
          </Grid>
        ))}
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          onClick={handleScrollToTop}
          // sx={{ backgroundColor: '#373737', borderRadius: '50%', width: '12%' }}
        >
          <img src={'/assets/appBarIcons/searchFooter.png'} alt="" width={'48px'} height={'48px'} />
        </Box>
        {footerItemsMobile?.slice(2, footerItemsMobile?.length)?.map((item, key) => (
          <Grid key={key} display="flex" alignItems="center">
            <Link href={item?.pathName} style={{ textDecoration: 'none' }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'column' },
                  alignItems: 'center',
                  marginRight: '5px',
                }}
              >
                {item?.itemName === 'Sell' ? (
                  <SellIcon color={location.pathname === item.pathName ? '#FFA800' : '#FFFFFF99'} />
                ) : (
                  // <DriveEtaIcon fontSize="small" className="head-icon-color" />
                  <DreamCarIcon color={location.pathname === item.pathName ? '#FFA800' : '#FFFFFF99'} />
                )}
                <Typography
                  textAlign={'center'}
                  fontSize={12}
                  fontWeight={400}
                  sx={{ color: location.pathname === item.pathName ? '#FFA800' : '#FFFFFF99' }}
                >
                  {item?.itemName}
                </Typography>
              </Box>
            </Link>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default Footer;
